export default __webpack_public_path__ + "static/media/right_dark.f5786829.png";